import React, { useState, useEffect } from "react"
// import { Link } from "gatsby"

import "./section-type-article.scss"
import Button from "../../../shared/components/atoms/button/button"

const SectionTypeArticle = props => {
  const [animationEffect, setanimationEffect] = useState("")

  useEffect(() => {
    setTimeout(() => {
      setanimationEffect("padding-animate")
    }, 100)
    return
  })
  return (
    <div className="f-sectiontypearticle ">
      <p className="f-sectiontypearticle-copy">¿Qué quieres ver?</p>
      <div className={"f-sectiontypearticle-tags " + animationEffect}>
        {props.typesArticles.map((info, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                props.setTypeActive(info.slug)
              }}
            >
              <Button
                className={
                  props.typeActive === info.slug
                    ? "primary-blue alter"
                    : "secondary-blue"
                }
                title={info.nombreEtiqueta}
              ></Button>{" "}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SectionTypeArticle
